import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

import auth from '../ducks/auth';
import channels from '../ducks/channels';
import taxons from '../ducks/taxons';
import menus from '../ducks/menus';
import pages from '../ducks/pages';
import products from '../ducks/products';
import eventProducts from '../ducks/eventProducts';
import ui from '../ducks/ui';
import cart from '../ducks/cart';
import user from '../ducks/user';
import affiliate from '../ducks/affiliate';
import misc from '../ducks/misc';
import reviews from '../ducks/reviews';
import search from '../ducks/search';

const rootReducer = combineReducers({
  auth,
  channels,
  taxons,
  menus,
  pages,
  products,
  eventProducts,
  cart,
  ui,
  user,
  affiliate,
  misc,
  reviews,
  search,
  routing: routerReducer,
  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./store/rootReducer.js